// Full-screen activity is explicit. Routine requests own their local loading UI.
const listeners = new Set();
const backgroundSignals = new WeakSet();
let pending = 0;

export const getRequestActivity = () => pending;
export const subscribeRequestActivity = listener => { listeners.add(listener); return () => listeners.delete(listener); };
const notify = () => listeners.forEach(listener => listener());

export function beginRequestActivity() {
  let finished = false;
  pending += 1; notify();
  return () => {
    if (finished) return;
    finished = true; pending -= 1; notify();
  };
}

export async function withRequestActivity(action) {
  const finish = beginRequestActivity();
  try { return await action(); }
  finally { finish(); }
}

// Keep the same AbortSignal so existing cancellation and stale-response guards
// remain authoritative. Weak references do not extend a request's lifetime.
export function backgroundSignal(signal) {
  if (signal && typeof signal === "object") backgroundSignals.add(signal);
  return signal;
}

export const isBackgroundSignal = signal => !!signal && backgroundSignals.has(signal);
// Request intent stays independent of overlay presentation: ordinary reads are
// interactive requests even when their loading UI stays inside a section.
export const isForegroundRequest = config => config.globalLoader !== false && !config.background && !config.accessRefresh
  && !isBackgroundSignal(config.signal);
export const usesFullPageLoader = config => config.globalLoader === true && isForegroundRequest(config);
